import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicSoftwareBoardSettingsInsightsRapidboardBoardRoute: InvariantJiraRoute = {
	name: 'rapidboard-board',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId',
	query: ['config=insightsConfig'],
};
